export enum SubscriptionPlanId {
  BIKETRAX_ONLY = 'BIKETRAX_SERVICE_PLAN',
  BIKTERAX_ONLY_WITH_ACTIVATION_FEE = 'BIKETRAX_SERVICE_PLAN_WITH_ACTIVATION_FEE',
  BIKETRAX_WITH_RECOVERY = 'BIKETRAX_RECOVERY_PLAN',
  UNKNOWN = 'UNKNOWN_PLAN',
}
